import { render, staticRenderFns } from "./AShop.vue?vue&type=template&id=315d5538&scoped=true&"
import script from "./AShop.vue?vue&type=script&lang=js&"
export * from "./AShop.vue?vue&type=script&lang=js&"
import style0 from "./AShop.vue?vue&type=style&index=0&id=315d5538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d5538",
  null
  
)

export default component.exports